import { Container } from 'react-bootstrap';
import styles from './styles.module.css';

const ProductLayout = ({ children, category }) => {
  return (
    <Container className={`${styles.container} shadow p-4`} style={{ marginBottom: '5em' }}>
      <h1>{category}</h1>
      {children}
    </Container>
  );
};

export default ProductLayout;
